import { createFileRoute } from "@tanstack/react-router";

import { config } from "@/config";

import designPowerImage from "../assets/LandingHero/designPower.webp";
import { faqJsonLdEntries } from "../components/landing-faq-data";
import Landing from "../pages/Landing";

import { homepageDescription } from "./__root";

const softwareApplicationJsonLd = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "Flowstep",
  url: "https://flowstep.ai",
  applicationCategory: "DesignApplication",
  operatingSystem: "Web",
  description: homepageDescription,
};

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqJsonLdEntries.map(({ question, answer }) => ({
    "@type": "Question",
    name: question,
    acceptedAnswer: {
      "@type": "Answer",
      text: answer,
    },
  })),
};

export const Route = createFileRoute("/")({
  component: Landing,
  head: () => ({
    meta: [
      { "script:ld+json": softwareApplicationJsonLd },
      { "script:ld+json": faqJsonLd },
    ] as unknown as React.JSX.IntrinsicElements["meta"][],
    links: [
      {
        rel: "preload",
        as: "image",
        href: designPowerImage,
        type: "image/webp",
        fetchPriority: "high",
      },
    ],
  }),
  beforeLoad: (props) => {
    const serverCookies = props.serverContext?.request?.headers.get("cookie");
    const cookies =
      serverCookies ?? (typeof document !== "undefined" ? document.cookie : "");

    const cookie = getCookie(cookies, "sb-apollo-auth-token.0");
    if (cookie) {
      throw Route.redirect({
        href: config.editorUrl,
        reloadDocument: true,
      });
    }
  },
});

function getCookie(cookies: string, cookieName: string): string | undefined {
  const value = `; ${cookies}`;
  const parts = value.split(`; ${cookieName}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift();
  return undefined;
}
